type CacheEntry =
    | { status: 'pending'; promise: Promise<void> }
    | { status: 'success' }
    | { status: 'error'; error: unknown };

const cache = new Map<string, CacheEntry>();

/**
 * Suspense-compatible image preloader.
 * Throws a Promise while loading, throws an Error on failure, returns normally when ready.
 */
export function preloadImage(src: string): void {
    let entry = cache.get(src);

    if (!entry) {
        const promise = new Promise<void>((resolve, reject) => {
            const img = new Image();
            img.onload = () => {
                cache.set(src, { status: 'success' });
                resolve();
            };
            img.onerror = (e) => {
                cache.set(src, { status: 'error', error: e });
                reject(e);
            };
            img.src = src;
        });

        entry = { status: 'pending', promise };
        cache.set(src, entry);
    }

    if (entry.status === 'pending') throw entry.promise;
    if (entry.status === 'error') throw entry.error;
}
